import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Card,
  ListItemSecondaryAction,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { getInitials, getFullName, toUserTimezone } from 'utils';
import LensIcon from '@material-ui/icons/Lens';
import { Virtuoso } from 'react-virtuoso';
import { USER_TYPES } from 'constant/userTypes';

const useStyles = makeStyles((theme) => ({
  unreadDot: {
    width: 12,
    height: 12,
  },
}));

const UserRow = ({ data, selected, classes, user }) => {
  const hasUnactioned = (convo) => {
    if (convo.unread)
      return (
        <ListItemSecondaryAction>
          <LensIcon color="primary" className={classes.unreadDot} />
        </ListItemSecondaryAction>
      );
    return null;
  };

  return (
    <ListItem
      divider
      button
      selected={selected === data.id}
      component={Link}
      to={`/inbox/sms/${data.id}`}
    >
      <ListItemAvatar>
        <Avatar src={data.user.user_pic}>
          {getInitials(data.user.name, data.user.user_last_name)}
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={`${getFullName(data.user)} - ${USER_TYPES[data.user.user_type]}`}
        secondary={data.last_message_at && `${toUserTimezone(data.last_message_at, user.timezone).format('MMM D, YY h:m A')} ${data.message}`}
        secondaryTypographyProps={{
          variant: 'caption',
          style: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          },
        }}
      />
      {hasUnactioned(data)}
    </ListItem>
  );
};

const UsersList = ({ users, selected }) => {
  const classes = useStyles();
  const user = useSelector((s) => s.user.user);

  const Components = useMemo(() => {
    return {
      List: React.forwardRef(({ style, children }, listRef) => {
        return (
          <List
            style={{padding: 0, ...style, margin: 0}}
            ref={listRef}
          >
            {children}
          </List>
        );
      }),
    };
  }, []);

  return (
    <Virtuoso
      components={Components}
      style={{
        height: 'calc(100vh - 210px)',
      }}
      data={users}
      itemContent={(index, item) => (
        <UserRow
          user={user}
          data={item}
          key={item.id}
          classes={classes}
          selected={selected}
        />
      )}
    />
  )
};

export default UsersList;
